module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAKCAYAAACE2W/HAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAADqADAAQAAAABAAAACgAAAABIcJ86AAAA2UlEQVQoFY2QMQrCQBBF/yRISm2NCha22nkA8RSeQUTwDh4gEW3FwmOIB7DTI0TtbYRgzLizmqC7Cbgw7PD/+7PDAiXHD3kkVWKDigx/yS1+4CgeVdC7jikyOccUmJnSBBsGalK6V5rJWcF6gBkYgxxUvdZy4d38TGouuPtMcWCG980RIXYd9M8TOmV6/mInZC9JsTVDAoomnjBW8A7M1YrdzLBu5WnmY+hVGwEPnsBOBX9Wt8IEdoHhZUp7aq+5Ft9wVD/YssACQU2OvCp6jgqt/g3JHGEl8wIk308zdSsEowAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/up.png
// module id = qY3/
// module chunks = 29